import { HoverCard } from '@gate/gui'
import styled from 'styled-components'

export const BaseHoverCardStyled = styled(HoverCard)`
  * {
    box-sizing: border-box;
  }

  .base-hover-card-wrop {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
  }
`
